<div class="card h-100" style="cursor: pointer;overflow-y: auto;">
  <div class="dashboard-card-top-section">
    <div class="btn btn-group px-0">
      <select class="btn bg-white border btn-sm" [(ngModel)]="filterType" (change)="getData()">
        <option class="dropdown-item" value="fixed">Fixed</option>
        <option class="dropdown-item" value="custom">Custom</option>
      </select>
      @if (timePeriodList && data.time_period && filterType=='fixed') {
        <select class="btn bg-white border btn-sm" style="height: fit-content;"
          [(ngModel)]="data.time_period" (change)="setFilter($event)">
          @for (entry of timePeriodList; track entry) {
            <option class="dropdown-item" [value]="entry.code">
            {{entry.display}}</option>
          }
        </select>
      }
      <input type="text" ngxDaterangepickerMd [hidden]="filterType!='custom'" class="btn bg-white border datepicker-search"
        placeholder="Choose date" showCancel="true" [singleDatePicker]="false" [autoApply]="false"
        [timePicker]="false" [timePickerIncrement]="1"
        [startKey]="'FROM'" [endKey]="'TO'" (change)="valueChange($event)" autocomplete="off" />
    </div>
    @if (!hideLabels) {
      <h4 class="flex-grow-1"><b> {{data.widget_name}}</b></h4>
    }
  </div>
  <div class="card-body">
    <div class="row h-100" (click)="getDrilldown()">
      <div class="col-sm-4 d-flex">

        @if (!data.image_url) {
          <i class="fa fa-user fa-5x m-auto"></i>
        }
        @if (data.image_url) {
          <img [src]="data.image_url">
        }
      </div>
      <div class="col-sm-8 m-auto">
        <h1 class="text-center"><b>{{response}}</b></h1>
      </div>
    </div>
  </div>
</div>